document.addEventListener('DOMContentLoaded', () => {
    const observerConfig = { childList: true, subtree: true };

    const processElement = (element) => {
        if (element.dataset.linkProcessed) return;

        let targetToAppendTo = null;
        let addressParts = [];

        if (element.classList.contains('sl-address-item')) {
            targetToAppendTo = element.querySelector('.sl-address-details');

            const selectors = ['.name', '.address', '.postal_zip', '.city', '.country'];
            addressParts = selectors.map(sel => element.querySelector(sel)?.textContent.trim());
        }
        else if (element.classList.contains('gm-style-iw-d')) {
            targetToAppendTo = element.querySelector('div');

            const selectors = ['.name', '.address', '.city', '.prov_state', '.country'];
            addressParts = selectors.map(sel => element.querySelector(sel)?.textContent.trim());
        }

        if (targetToAppendTo) {
            const destinationQuery = addressParts.filter(Boolean).join(', ');

            if (destinationQuery) {
                const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destinationQuery)}`;

                const btn = document.createElement('a');
                btn.href = directionsUrl;
                btn.target = "_blank";
                btn.textContent = "Get Directions";

                Object.assign(btn.style, {
                    display: 'block',
                    width: 'fit-content',
                    marginTop: '10px',
                    padding: '8px 14px',
                    backgroundColor: '#BCAE84',
                    color: '#ffffff',
                    textDecoration: 'none',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    fontSize: '13px'
                });

                targetToAppendTo.appendChild(btn);
                element.dataset.linkProcessed = 'true';
            }
        }
    };

    const handleMutations = (mutationsList) => {
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList.contains('sl-address-item') || node.classList.contains('gm-style-iw-d')) {
                            processElement(node);
                        }
                        node.querySelectorAll('.sl-address-item, .gm-style-iw-d').forEach(processElement);
                    }
                });
            }
        });
    };

    const rootObserver = new MutationObserver(() => {
        const listContainer = document.querySelector('.sl-addresses');
        if (listContainer && !listContainer.dataset.isObserved) {
            new MutationObserver(handleMutations).observe(listContainer, observerConfig);
            listContainer.dataset.isObserved = 'true';

            listContainer.querySelectorAll('.sl-address-item').forEach(processElement);
        }

        const mapContainer = document.querySelector('.gm-style');
        if (mapContainer && !mapContainer.dataset.isObserved) {
            new MutationObserver(handleMutations).observe(mapContainer, observerConfig);
            mapContainer.dataset.isObserved = 'true';

            mapContainer.querySelectorAll('.gm-style-iw-d').forEach(processElement);
        }
    });

    rootObserver.observe(document.body, observerConfig);
});

function addCustomZoomControls(map) {
    const controlContainer = document.createElement('div');
    controlContainer.style.margin = '10px';
    controlContainer.style.display = 'flex';
    controlContainer.style.flexDirection = 'column';
    controlContainer.style.gap = '2px';
    controlContainer.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlContainer.style.borderRadius = '2px';
    controlContainer.style.overflow = 'hidden';
    controlContainer.style.position = 'relative';
    controlContainer.style.width = 'fit-content';

    const zoomInBtn = document.createElement('button');
    zoomInBtn.innerHTML = '+';
    zoomInBtn.title = 'Zoom In';
    applyButtonStyles(zoomInBtn);

    const zoomOutBtn = document.createElement('button');
    zoomOutBtn.innerHTML = '−';
    zoomOutBtn.title = 'Zoom Out';
    applyButtonStyles(zoomOutBtn);

    controlContainer.appendChild(zoomInBtn);
    controlContainer.appendChild(zoomOutBtn);

    zoomInBtn.addEventListener('click', () => {
        const currentZoom = map.getZoom();
        map.setZoom(currentZoom + 1);
    });

    zoomOutBtn.addEventListener('click', () => {
        const currentZoom = map.getZoom();
        map.setZoom(currentZoom - 1);
    });

    document.querySelector(".sl-map").appendChild(controlContainer);
    console.log(document.querySelector(".sl-map"))
}

function applyButtonStyles(button) {
    button.style.backgroundColor = '#fff';
    button.style.border = 'none';
    button.style.outline = 'none';
    button.style.width = '40px';
    button.style.height = '40px';
    button.style.cursor = 'pointer';
    button.style.fontSize = '20px';
    button.style.fontWeight = '500';
    button.style.color = '#666';

    button.addEventListener('mouseenter', () => button.style.color = '#333');
    button.addEventListener('mouseleave', () => button.style.color = '#666');
}

function changeStandardMarkerColor(marker) {
    const newPinColor = new google.maps.marker.PinElement({
        background: "#BCAE84",
        borderColor: "#FFFFFF",
        glyphColor: "#FFFFFF"
    });

    marker.content = newPinColor.element;
}

window.addEventListener("load", () => {
    const polling = setInterval(() => {
        if (SL && SL.map) {
            clearInterval(polling);
            addCustomZoomControls(SL.map);

            SL.markers.forEach(m => changeStandardMarkerColor(m));
        }
    }, 100);

    setTimeout(() => clearInterval(polling), 20000);
});